const GoodsCategory = () => import('@/views/Shop/goods-category.vue')
const Goods = () => import('@/views/Shop/goods.vue')
const GoodsAdd = () => import('@/views/Shop/goods-add.vue')
const Coupon = () => import('@/views/Shop/coupon.vue')
const CouponCar = () => import('@/views/Shop/coupon-car.vue')

const router = [
  {
    meta: {title: '商品分类', route: 'goods_category_index'},
    path: 'goods-category',
    name: 'goods-category',
    component: GoodsCategory
  },
  {
    meta: {title: '商品列表', route: 'goods_index'},
    path: 'goods-list',
    name: 'goods-list',
    component: Goods
  },
  {
    meta: {title: '新增商品', route: 'goods_add'},
    path: 'goods-add',
    name: 'goods-add',
    component: GoodsAdd
  },
  {
    meta: {title: '优惠券', route: 'coupon_index'},
    path: 'coupon',
    name: 'coupon',
    component: Coupon
  },
  {
    meta: {title: '洗车券', route: 'coupon_car_index'},
    path: 'coupon-car',
    name: 'coupon-car',
    component: CouponCar
  }
]
module.exports = {router};
